export default "__VITE_ASSET__2c29766b__"